import { parseCookie } from "cookie";


const tokensFromCookie = (cookies = []) => {
  // Note: must be using `cookie-parser` express middleware or compatible
  // TODO: consider using the cookie parser `cookie` like above
  let srcObj = parseCookie(document.cookie)

  let result = cookies.reduce((obj, cookie) => {
    if (srcObj[cookie]) {
      return {
        ...obj,
        [cookie]: srcObj[cookie],
      };
    } else {
      return obj;
    }
  }, {});
  return result;
};

export default tokensFromCookie;
